/** The MailPilot logo: an envelope folding into a paper plane on a blue tile (same as the app icon). */
export function BrandMark({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 1024 1024" aria-hidden className={className} style={{ flex: 'none', filter: 'drop-shadow(0 6px 14px rgb(10 92 242 / 0.28))' }}>
      <defs>
        <linearGradient id="mp-tile" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#22B4FF" />
          <stop offset="0.45" stopColor="#0A5CF2" />
          <stop offset="1" stopColor="#0A2BA6" />
        </linearGradient>
        <linearGradient id="mp-paper" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#EAF2FF" />
        </linearGradient>
        <linearGradient id="mp-wing" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#D6E6FF" />
          <stop offset="1" stopColor="#F4F8FF" />
        </linearGradient>
        <linearGradient id="mp-flap" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1846D9" />
          <stop offset="1" stopColor="#2F7BFF" />
        </linearGradient>
      </defs>
      <rect width="1024" height="1024" rx="228" fill="url(#mp-tile)" />
      <path d="M168 395 L918 197 L704 777 Q692 823 648 823 L212 823 Q146 823 146 758 L146 456 Q146 406 168 395 Z" fill="url(#mp-paper)" />
      <path d="M512 680 L858 254 L918 197 L704 777 Z" fill="url(#mp-wing)" />
      <path d="M244 404 L417 508 L512 680 L858 254 Z" fill="url(#mp-flap)" />
    </svg>
  );
}
